import {
  SpaceBetween,
} from "@cloudscape-design/components";
import { useEffect, useContext } from "react";
import { 
  View, 
  useTheme, 
  Image, 
  Text, 
  Heading, 
  useAuthenticator, 
  Authenticator, 
  Button, 
  Grid, 
  Flex 
} from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
import './amplify_styles.css'
import { useNavigate, useLocation } from 'react-router';
import { GlobalContext } from "../../context";
import * as awsui from "@cloudscape-design/design-tokens";
import { leagueId } from "../../leagueId";
import { Mode } from "@cloudscape-design/global-styles";


export function Login() {
  const { 
    userAttributes, setUserAttributes,
    authInitialState, setAuthInitialState,
    theme, setTheme,
    pathname, setPathname,
  } = useContext(GlobalContext);
  const { user, signOut, toSignIn, toSignUp, toResetPassword } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  const { authStatus } = useAuthenticator(context => [context.authStatus]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (route === 'authenticated') {
      setUserAttributes(user.getSignInUserSession()!.getIdToken().payload)
      navigate(pathname);
    }
  }, [route, navigate]);

  const components = {
    Header() {
      const { tokens } = useTheme();
  
      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="FRG logo"
            src={theme === Mode.Light ? "/images/frg-logo-dark.png" : "/images/frg-logo-light.png"}
          />
        </View>
      );
    },
  
    Footer() {
      const { tokens } = useTheme();
  
      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Text color={awsui.colorTextBodySecondary}>
            &copy; All Rights Reserved
          </Text>
        </View>
      );
    },
  
    SignIn: {
      Header() {
        const { tokens } = useTheme();
  
        return (
          <></>
          // <Heading
          //   padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          //   level={3}
          // >
          //   Sign in to your account
          // </Heading>
        );
      },
      Footer() {
        const { toResetPassword } = useAuthenticator();
  
        return (
          <View textAlign="center">
            {/* <Button 
              className="amplify-button amplify-field-group__control" 
              // data-fullwidth="true"
              width={"60%"} 
              variation="link" 
              type="button"
              onClick={CancelAuth}
            >
              Cancel
            </Button> */}
            <p />
            <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              Reset Password
            </Button>
          </View>
        );
      },
    },
  
    SignUp: {
      Header() {
        const { tokens } = useTheme();
  
        return (
          <></>
          // <Heading
          //   padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          //   level={3}
          // >
          //   Create a new account
          // </Heading>
        );
      },
      Footer() {
        const { toSignIn } = useAuthenticator();
  
        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              Back to Sign In
            </Button>
          </View>
        );
      },
    },
    ConfirmSignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
      
    },
    SetupTOTP: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
    ConfirmSignIn: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
    ResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Reset Password:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
    ConfirmResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
  };
  
  const formFields = {
    signIn: {
      username: {
        placeholder: 'Enter your username',
        order: 1,
      },
    },
    signUp: {
      username: {
        placeholder: 'Enter username',
        isRequired: false,
        order: 1,
      },
      email: {
        type: 'email',
        placeholder: 'Enter email',
        isRequired: true,
        order: 2,
      }, 
      given_name: {
        type: 'given_name',
        label: 'First name',
        placeholder: 'Enter first name',
        isRequired: true,
        order: 3,
      },
      family_name: {
        type: 'family_name',
        label: 'Last name',
        placeholder: 'Enter last name',
        isRequired: true,
        order: 4,
      },
      // birthdate: {
      //   label: 'Birthdate',
      //   isRequired: false,
      //   order: 5,
      // },
      password: {
        label: 'Password:',
        placeholder: 'Enter Password',
        isRequired: true,
        order: 10,
      },
      confirm_password: {
        label: 'Confirm Password',
        isRequired: true,
        order: 11,
      },
      league_id: {
        name: 'custom:leagueId',
        label: '',
        isRequred: true,
        value: leagueId,
        hidden: true,
      },
      // iRacingCustomerId: {
      //   name: 'custom:iRacingCustomerId',
      //   label: 'iRacing customer ID',
      //   placeholder: '123456',
      //   isRequired: true,
      //   order: 6,
      //   hint: 'Log into iRacing to find your customer id',
      // },
      // iRacingDriverName: {
      //   name: 'custom:iRacingDriverName',
      //   label: 'iRacing driver name',
      //   isRequired: true,
      //   order: 7,
      //   hint: 'Your driver name in iRacing, including any numbers',
      // },
      // discordUserID: {
      //   name: 'custom:discordUserId',
      //   label: 'Discord user ID',
      //   placeholder: '752359355582278977',
      //   isRequired: true,
      //   order: 8,
      //   hint: 'Log into Discord to find your user id',
      // },
      // maLicenceId: {
      //   name: 'custom:maLicenceId',
      //   label: 'Motorsport Australia Licence ID',
      //   placeholder: '123456789',
      //   isRequired: false,
      //   order: 9,
      //   hint: 'Apply for an licence on the MA e-sports website',
      // },
    },
    forceNewPassword: {
      password: {
        placeholder: 'Enter your Password:',
      },
    },
    resetPassword: {
      email: {
        placeholder: 'Enter your email:',
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Enter your Confirmation Code:',
        label: 'New Label',
        isRequired: false,
      },
      confirm_password: {
        placeholder: 'Enter your Password Please:',
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
  };
  
  const socialProviders: any = [
      "google",
      // "facebook",
    ]
  
  const loginMechanisms: any = [
    "username"
  ]
  
  const signUpAttributes: any = [
    // "email",
    // "birthdate",
    // "name",
  ]
    
  return (
    <Grid templateColumns={{ base: "1fr 0", medium: "1fr 1fr" }}>
      <Flex
        backgroundColor={awsui.colorBackgroundLayoutMain} 
        justifyContent="center"
      >
      <View className="auth-wrapper" height={"100%"}>
        <Authenticator
          // variation="modal"
          formFields={formFields} 
          components={components} 
          socialProviders={socialProviders}
          loginMechanisms={loginMechanisms}
          initialState={authInitialState}
          username-alias="email"
          // signUpAttributes={signUpAttributes}
        >
        </Authenticator>
      </View>
      </Flex>
      <View height="100%">
        <Image
          // src="https://images.unsplash.com/photo-1495954222046-2c427ecb546d?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=1600&ixid=MnwxfDB8MXxyYW5kb218MHx8Y29tcHV0ZXJzfHx8fHx8MTYzNzE5MzE2MQ&ixlib=rb-1.2.1&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=900"
          src="/images/helmet-blurred-background.png"
          alt="img"
          width="100%"
          height="100%"
          objectFit="cover"
        />
      </View>
    </Grid>
  );
}